import GreyOpacityText from "../UI/textFields/GreyOpacityText";
import TinyDivider from "../UI/TinyDivider";
import headerStyles from "../../styles/header.module.css";
import labels from "../../utils/labels";
import useDataSelector from "../../hooks/useDataSelector";
import HoverBoxAnchor from "../UI/hoverBox/HoverBoxAnchor";

const HeaderKPIList = () => {
  const { dataToUse } = useDataSelector();
  const kpis = dataToUse?.generalGanttChartInfo.kpis;

  return (
    <div className={headerStyles.kpiList}>
      {/* Medarbejdere: headcount + total arbejdstid (unaffected by isWithinWorkTime).
          No divider between the pair within a category — tight spacing + the shared
          "timer" label read as one unit, category groups are separated by a divider
          and a wider gap instead. */}
      <HoverBoxAnchor
        tooltipText={labels.employeeCategoryTooltip(
          kpis?.employees ?? 0,
          kpis?.employeeWorkHours ?? 0,
        )}
      >
        <div className={headerStyles.kpiCategory}>
          <GreyOpacityText key={labels.employees.toLowerCase()} size="SMALL">
            {kpis?.employees} {labels.employees.toLowerCase()}
          </GreyOpacityText>
          <GreyOpacityText key="employee-hours" size="SMALL">
            {kpis?.employeeWorkHours} {labels.hours.toLowerCase()}
          </GreyOpacityText>
        </div>
      </HoverBoxAnchor>
      <TinyDivider colorVariant="PRIMARY"></TinyDivider>
      {/* Borgere: visit count + visit hours, both always including uplanlagte */}
      <HoverBoxAnchor
        tooltipText={labels.citizenVisitCategoryTooltip(
          kpis?.visits ?? 0,
          kpis?.visitTotalHours ?? 0,
        )}
      >
        <div className={headerStyles.kpiCategory}>
          <GreyOpacityText key={labels.citizenVisits.toLowerCase()} size="SMALL">
            {kpis?.visits} {labels.citizenVisits.toLowerCase()}
          </GreyOpacityText>
          <GreyOpacityText key="visit-hours" size="SMALL">
            {kpis?.visitTotalHours} {labels.hours.toLowerCase()}
          </GreyOpacityText>
        </div>
      </HoverBoxAnchor>
      <TinyDivider colorVariant="PRIMARY"></TinyDivider>
      {/* Medarbejderaftaler: count + hours, both scoped to within arbejdstid */}
      <HoverBoxAnchor
        tooltipText={labels.employeeAppointmentCategoryTooltip(
          kpis?.calendarEvents ?? 0,
          kpis?.calendarEventHours ?? 0,
        )}
      >
        <div className={headerStyles.kpiCategory}>
          <GreyOpacityText
            key={labels.employeeAppointments.toLowerCase()}
            size="SMALL"
          >
            {kpis?.calendarEvents} {labels.employeeAppointments.toLowerCase()}
          </GreyOpacityText>
          <GreyOpacityText key="employee-appointment-hours" size="SMALL">
            {kpis?.calendarEventHours} {labels.hours.toLowerCase()}
          </GreyOpacityText>
        </div>
      </HoverBoxAnchor>
    </div>
  );
};

export default HeaderKPIList;
